export default __webpack_public_path__ + "static/howFWAWorksStep5-0d074b8298386915cf44669651dce9d1.png";